export const patientRows = [
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'Philip. Cammee John',
    '03/06/2006 (20 yrs)',
    '21040897',
    'Star Health',
    'United Health Care',
    '916-496-2753'
  ],
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'Philip. Cammee John',
    '03/06/2006 (20 yrs)',
    '21040897',
    'Star Health',
    'United Health Care',
    '916-496-2753'
  ],
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'Alice Johnson',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'Star Health',
    'United Health Care',
    '916-496-2753'
  ],
  [
    'Philip. Cammee John',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'Star Health',
    'United Health Care',
    '916-496-2753'
  ],
  [
    'Philip. Cammee John',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'James',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'Philip. Cammee John',
    '03/06/2006 (20 yrs)',
    '21040897',
    'Star Health',
    'United Health Care',
    '916-496-2753'
  ],
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'Philip. Cammee John',
    '03/06/2006 (20 yrs)',
    '21040897',
    'Star Health',
    'United Health Care',
    '916-496-2753'
  ],
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'Alice Johnson',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'Star Health',
    'United Health Care',
    '916-496-2753'
  ],
  [
    'Philip. Cammee John',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'Star Health',
    'United Health Care',
    '916-496-2753'
  ],
  [
    'Philip. Cammee John',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'Philip. Cammee John',
    '03/06/2006 (20 yrs)',
    '21040897',
    'Star Health',
    'United Health Care',
    '916-496-2753'
  ],
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'Philip. Cammee John',
    '03/06/2006 (20 yrs)',
    '21040897',
    'Star Health',
    'United Health Care',
    '916-496-2753'
  ],
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'Alice Johnson',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'Star Health',
    'United Health Care',
    '916-496-2753'
  ],
  [
    'Philip. Cammee John',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ],
  [
    'James Hunt',
    '03/06/2006 (20 yrs)',
    '21040897',
    'Star Health',
    'United Health Care',
    '916-496-2753'
  ],
  [
    'Philip. Cammee John',
    '03/06/2006 (20 yrs)',
    '21040897',
    'United Health Care',
    'Star Health',
    '916-496-2753'
  ]
];

export const columns = [
  {
    field: 'pname',
    headerName: 'Patient Name',
    width: '20%',
    primary: true,
    skeletonWidth: '60%'
  },
  {
    field: 'dob',
    headerName: 'Date of Birth',
    width: '16%',
    skeletonWidth: '55%'
  },
  {
    field: 'mr',
    headerName: 'MR#',
    width: '12%',
    skeletonWidth: '45%'
  },
  {
    field: 'pri',
    headerName: 'Primary Insurance',
    width: '18%',
    skeletonWidth: '70%'
  },
  {
    field: 'seco',
    headerName: 'Secondary Insurance',
    width: '18%',
    skeletonWidth: '70%'
  },
  {
    field: 'phn',
    headerName: 'Phone Number',
    width: '16%',
    skeletonWidth: '55%'
  }
];